module.exports = {
      id: "arrow-down-usage",
      viewBox: "0 0 512 512",
      url: "/" + "svg-sprite-e82dc0c57c0a843613ac9ad873433208.svg#arrow-down",
      toString: function () {
        return this.url;
      }
    }